import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TOCState {
    pages: number[];
    chapters: { [page: number]: string };
}

const initialState: TOCState = {
    pages: [],
    chapters: {},
};

const extractPageNumber = (href: string): number => {
    const match = href.match(/\d+/);
    return match && match[0] ? parseInt(match[0], 10) : 0;
};

const initialTOCDataSlice = createSlice({
    name: 'initialTOCData',
    initialState,
    reducers: {
        setTOCData(
            state,
            action: PayloadAction<{ title: string; href: string }[]>
        ) {
            const chapters = action.payload;

            state.pages = [];
            state.chapters = {};

            chapters.forEach((chapter) => {
                const pageNumber = extractPageNumber(chapter.href);
                state.pages.push(pageNumber);
                state.chapters[pageNumber] = chapter.title;
            });

            state.pages.sort((a, b) => a - b);
        },
    },
});

export const { setTOCData } = initialTOCDataSlice.actions;
export default initialTOCDataSlice.reducer;
